import NavigationBase from "./base.js";


/**
 * Контроллер для мобильной шапки
 **/

const NavigationMobile = NavigationBase.extend(
    {
        defaults: {
            panel: 'panel-menu--mobile',
            shower: '[js-show--panel]',
            closer: '[js-close--panel]',
            close_panel: 'button.j-close__panel',
            btn_search: '.j-show__search'
        }
    },
    {
        init() {
            const _this = this;

            const _shower = document.querySelector(this.options.shower);
            const closer = document.querySelector(this.options.closer);
            const _panel = document.getElementById(this.options.panel);

            _shower.addEventListener('click', (event) => {
                _this.show(_panel, _shower);
                _shower.querySelector('.icon').classList.add('icon-close');
            });

            closer.addEventListener('click', (event) => {
                _this.close(_panel, _shower);
                _shower.querySelector('.icon').classList.remove('icon-close');
            });

            //TODO class with context
            document.addEventListener('touchstart', handleTouchStart, false);
            document.addEventListener('touchmove', handleTouchMove, false);

            var xDown = null;
            var yDown = null;

            function getTouches(evt) {
                return evt.touches ||             // browser API
                    evt.originalEvent.touches; // jQuery
            }

            function handleTouchStart(evt) {
                const firstTouch = getTouches(evt)[0];
                xDown = firstTouch.clientX;
                yDown = firstTouch.clientY;
            }

            function handleTouchMove(evt) {
                if (!xDown || !yDown) {
                    return;
                }

                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;

                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
                    if (xDiff > 0) {
                        /* right swipe */
                        if (_panel.classList.contains("show")) {
                            _this.close(_panel, _shower);
                        }

                    } else {
                        /* left swipe */
                        if (_panel.classList.contains("show")) {
                            _this.close(_panel, _shower);
                        }

                    }
                } else {
                    if (yDiff > 0) {

                        /* down swipe */
                    } else {

                        /* up swipe */
                    }
                }
                /* reset values */
                xDown = null;
                yDown = null;
            }

            this._super();
        },
        show(panel, shower) {
            panel.classList.add('show');
            shower.querySelector('.icon').classList.add('icon-close');
        },
        close(panel, shower) {
            panel.classList.remove('show');
            shower.querySelector('.icon').classList.remove('icon-close');
        },
        '{btn_search} click'(el) {
            $(el).toggleClass("active");
            $(".site-search__mobile").toggleClass("active");
        }
    }
);

export default NavigationMobile;